import React, {Component} from "react";
import {connect} from "react-redux";

import Home from "../views/page/Home";
import About from "../views/page/About";

import "./PageViewLayout.css";

class PageViewLayout extends Component {

  render() {
    const {hashParts} = this.props;
    return (
      <div id="fow-page-view-layout">
        {hashParts.view === "home" && <Home />}
        {hashParts.view === "about" && <About />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hashParts: state.settings.hashParts
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PageViewLayout);
